import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

// API
export interface ListOfForumsFetchAction extends Action {
    readonly username: string;
    readonly after: number;
}

export interface ListOfForumsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        categories: number[];
        contestsTopic: number;
        followingTopics: number[];
        topics: number[];
        testingsTopic: number;
    };
}

export const LIST_OF_FORUMS_FETCH_REQUEST = "LIST_OF_FORUMS_FETCH_REQUEST";
export interface ListOfForumsFetchRequestAction extends ListOfForumsFetchAction, APIRequestAction {
    readonly type: typeof LIST_OF_FORUMS_FETCH_REQUEST;
}

export const LIST_OF_FORUMS_FETCH_SUCCESS = "LIST_OF_FORUMS_FETCH_SUCCESS";
export interface ListOfForumsFetchSuccessAction
    extends ListOfForumsFetchAction, APISuccessAction<ListOfForumsFetchNormalizedResponse> {
    readonly type: typeof LIST_OF_FORUMS_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
}

export const LIST_OF_FORUMS_FETCH_FAILURE = "LIST_OF_FORUMS_FETCH_FAILURE";
export interface ListOfForumsFetchFailureAction extends ListOfForumsFetchAction, APIFailureAction {
    readonly type: typeof LIST_OF_FORUMS_FETCH_FAILURE;
}

export const listOfForumsFetch = {
    request: (username: string, after: number): ListOfForumsFetchRequestAction => ({
        type: LIST_OF_FORUMS_FETCH_REQUEST,
        username,
        after,
    }),
    success: (
        username: string,
        after: number,
        hasNext: number,
        hasPrevious: number,
        response: ListOfForumsFetchNormalizedResponse,
    ): ListOfForumsFetchSuccessAction => ({
        type: LIST_OF_FORUMS_FETCH_SUCCESS,
        response,
        username,
        after,
        hasNext,
        hasPrevious,
    }),
    failure: (username: string, after: number, error: string): ListOfForumsFetchFailureAction => ({
        type: LIST_OF_FORUMS_FETCH_FAILURE,
        error,
        username,
        after,
    }),
};

// Triggers
export const LIST_OF_FORUMS_LOAD = "LIST_OF_FORUMS_LOAD";

export interface ListOfForumsLoadAction extends ListOfForumsFetchAction {
    readonly type: typeof LIST_OF_FORUMS_LOAD;
}

export const listOfForumsLoad = (username: string, after?: number): ListOfForumsLoadAction => ({
    type: LIST_OF_FORUMS_LOAD,
    username,
    after,
});
